var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 248,
    viewBox: "0 0 441 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.266 225.187C341.717 225.187 440.172 201.578 440.172 172.453C440.172 143.329 341.717 119.719 220.266 119.719C98.8149 119.719 0.359375 143.329 0.359375 172.453C0.359375 201.578 98.8149 225.187 220.266 225.187Z",
    fill: "url(#paint0_radial_6672_52110)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290.656 197.465H149.879C145.899 197.465 142.672 194.238 142.672 190.258V91.9748C142.672 89.2691 143.974 86.7287 146.17 85.1487L215.357 35.3776C218.291 33.2673 222.245 33.2673 225.178 35.3776L294.366 85.1487C296.562 86.7287 297.864 89.2691 297.864 91.9748V190.258C297.864 194.238 294.637 197.465 290.656 197.465H290.656Z",
    fill: "#DDE3E6",
    stroke: "#DDE3E6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.459 135.791C230.434 136.534 229.65 136.256 229.081 137.27L226.027 134.651C222.714 131.809 217.822 131.809 214.508 134.651L211.455 137.27C210.886 136.256 210.102 136.534 209.077 135.791L142.672 92.4727L142.672 190.26C142.672 194.24 145.899 197.467 149.88 197.467H290.656C294.637 197.467 297.864 194.24 297.864 190.26L297.864 92.4727L231.459 135.791Z",
    fill: "white",
    stroke: "#DDE3E6",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.672 92.4707L211.794 138.179",
    stroke: "#DDE3E6",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297.864 92.4707L228.742 138.179",
    stroke: "#DDE3E6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.672 190.257L214.2 135.551C217.781 132.811 222.754 132.811 226.336 135.551L297.863 190.257",
    stroke: "#DDE3E6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M222.104 0C192.944 0 169.305 23.6391 169.305 52.7995C169.305 81.9599 192.944 105.599 222.104 105.599C251.265 105.599 274.904 81.9598 274.904 52.7995C274.904 23.6391 251.265 0 222.104 0Z",
    fill: "#00F2F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M216.681 77.3635C215.759 77.3635 214.837 77.0116 214.133 76.3077L194.939 57.1134C193.531 55.7068 193.531 53.424 194.939 52.0174C196.346 50.6097 198.627 50.6097 200.035 52.0174L216.681 68.6637L248.19 37.1554C249.598 35.7477 251.879 35.7477 253.286 37.1554C254.694 38.5631 254.694 40.8448 253.286 42.2514L219.229 76.3077C218.525 77.0116 217.603 77.3635 216.681 77.3635Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.141 52.8008C276.141 82.6408 251.951 106.831 222.111 106.831C192.271 106.831 168.081 82.6408 168.081 52.8008M293.508 52.8011C293.508 92.2338 261.542 124.2 222.109 124.2C182.677 124.2 150.71 92.2338 150.71 52.8011M310.315 52.8038C310.315 101.516 270.826 141.005 222.114 141.005C173.402 141.005 133.913 101.516 133.913 52.8038M327.419 52.8038C327.419 110.964 280.271 158.113 222.11 158.113C163.949 158.113 116.801 110.964 116.801 52.8038M345.453 52.8054C345.453 120.92 290.235 176.139 222.119 176.139C154.004 176.139 98.7861 120.92 98.7861 52.8054M363.457 52.804C363.457 130.868 300.174 194.151 222.11 194.151C144.047 194.151 80.7636 130.868 80.7636 52.804M382.052 52.8037C382.052 141.135 310.445 212.742 222.114 212.742C133.782 212.742 62.1756 141.135 62.1756 52.8037M398.965 52.8024C398.965 150.471 319.789 229.647 222.12 229.647C124.452 229.647 45.2759 150.471 45.2759 52.8024M416.119 52.8021C416.119 159.946 329.262 246.803 222.118 246.803C114.974 246.803 28.1172 159.946 28.1172 52.8021",
    stroke: "#F8F9F9",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6672_52110",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.266 172.452) scale(204.622 46.5494)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE3E6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordConfirmed);
export default __webpack_public_path__ + "static/media/password_confirmed.505633077771c3e9481670d53a8dec40.svg";
export { ForwardRef as ReactComponent };